import { Component, OnInit } from '@angular/core';
import { PartenariatService } from 'src/app/_services/partenariat/partenariat.service';
import { Partenariat } from 'src/app/Model/partenariat';
declare const myTest: any;
@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.css']
})
export class SponsorsComponent implements OnInit {
  SponsorOfficiel: Partenariat[] = [];
  SponsorFont: Partenariat[] = [];
  filterargs = { type: 'Officiel' };
  constructor(private sponsorService: PartenariatService) { }
  ngOnInit(): void {
    myTest();
   
    this.sponsorService.Afficherpartenariat().subscribe(res => {
     
      res.filter(el =>{
       
        if(el.type == "font")
        {
          this.SponsorFont.push(el)
        }else
        {
          this.SponsorOfficiel.push(el)
        }
      });
    //  console.log(this.SponsorFont)
    //  console.log(this.SponsorOfficiel)
    })
  }


}
